import { PARTY_ROLE } from './db-constants.js';
/**
 * File format scopes exposed by the admin API.
 *
 * - `system`: format applies to all parties (party_id IS NULL).
 * - `client`: format applies to a buyer (client) party.
 * - `provider`: format applies to an upstream provider party (supplier, bank,
 *   card processor, or network).
 */
export const FILE_FORMAT_SCOPE = {
    SYSTEM: 'system',
    PROVIDER: 'provider',
    CLIENT: 'client',
};
/**
 * Hardcoded mapping from the API-level `scope` filter to the party_role IDs
 * each scope encompasses. Co-located with the PARTY_ROLE source of truth so
 * DB seeds, migrations, and API filters agree on the same membership.
 *
 * `system` is not in this map because system-wide formats have no party at
 * all (party_id IS NULL); they are filtered separately.
 */
export const FILE_FORMAT_SCOPE_TO_PARTY_ROLES = {
    [FILE_FORMAT_SCOPE.CLIENT]: [PARTY_ROLE.BUYER],
    [FILE_FORMAT_SCOPE.PROVIDER]: [
        PARTY_ROLE.SUPPLIER,
        PARTY_ROLE.BANK,
        PARTY_ROLE.CARD_PROCESSOR,
        PARTY_ROLE.NETWORK,
    ],
};
//# sourceMappingURL=file-format-constants.js.map